module.exports = __webpack_public_path__ + "static/media/alert-triangle_red.e7e39ecf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/alert-triangle_red.svg
// module id = 844
// module chunks = 21